import { Dependencies } from "../interfaces/dependencies-types";

export class ChatController implements Dependencies {
    private haveChat = false;
    private chatElement: HTMLElement;
    private userTryTooOpen = false;

    private chatEventsArray: any[] = [];

    public async initialize() {
        this.subscriberForLoadScript();
    }

    private chatScript() {
        if (window.fcWidget) {
            this.emitEvent('chat-object', 'success');
            this.betterEventListenerLoadOfChatElement();

            if (window.fcWidget.isLoaded()) {
                this.onSuccessLoadedChat();
            } else {
                window.fcWidget.on('widget:loaded', (resp: any) => {
                    this.onSuccessLoadedChat();
                    if (this.userTryTooOpen) {
                        this.openChat(undefined);
                    }
                });
            }
            return true;
        } else {
            return false;
        }
    }

    public chatIsOpen() {
        if (window.fcWidget && window.fcWidget.isLoaded()) {
            return window.fcWidget.isOpen();
        }
        return false;
    }

    public openChat(doAfterOpen: Function) {
        if (this.haveChat) {
            window.fcWidget.open();
            this.chatElement.classList.add('open-aboveOBF');

            if (doAfterOpen) {
                doAfterOpen();
            }
        } else {
            this.userTryTooOpen = true;
            // user try too open it
        }
    }

    public closeChat(doAfterOpen: Function) {
        if (this.haveChat) {
            window.fcWidget.close();
            if (doAfterOpen) {
                doAfterOpen();
            }
        }
    }

    public feedData(data) {
        if (window.fcWidget && window.fcWidget.isLoaded()) {
            window.fcWidget.user.setProperties(data).then(resp => {
            }).catch(e => {
            });
        }
    }

    public sendEvent(eventObject) {
        if(window.fcWidget && window.fcWidget.isLoaded()) {
            window.fcWidget.track(eventObject.event, eventObject.data);
        }
    }

    private openStatusListener() {
        window.fcWidget.on('widget:opened', (resp: any) => {
            this.userTryTooOpen = false;
            this.emitEvent('chat-status', 'open');
            this.chatElement.classList.add('open-aboveOBF');
        });
    }

    private onSuccessLoadedChat() {
        this.haveChat = true;
        this.emitEvent('chat-loaded', 'success');
        this.openStatusListener();
        this.onCloseListener();
    }

    private onCloseListener() {
        if (this.haveChat) {
            window.fcWidget.on('widget:closed', (resp: any) => {
                this.emitEvent('chat-status', 'close');
                this.chatElement.classList.remove('open-aboveOBF');
            });
        }
    }

    private subscriberForLoadScript() {
        // const timeOutChat = setTimeout(() => {
        //     clearInterval(intervalInstance);
        //     this.emitEvent('chat-object', 'error');
        // }, 30000);

        const intervalInstance = setInterval(() => {
            if (this.chatScript()) {
                clearInterval(intervalInstance);
                //clearTimeout(timeOutChat);
            }
        }, 100);
    }

    private betterEventListenerLoadOfChatElement() {
        const intervalInstance = setInterval(() => {
            const chatElement: HTMLElement = document.querySelector('#fc_frame');
            if (chatElement) {
                this.emitEvent('chat-element', chatElement);
                this.chatElement = chatElement;
                this.chatElement.classList.add('obf-inSite');
                clearInterval(intervalInstance);
            }
        }, 10);
    }

    public onStatesListener(callback: Function) {
        this.chatEventsArray.push(callback);
    }

    private emitEvent(eventType: string, data: any) {
        this.chatEventsArray.map(el => {
            el({ type: eventType, data: data });
        });
    }
}
